import { Chip, ChipProps } from '@nextui-org/react';
import { RoleType } from '../../types';
import { useMemo } from 'react';
import { ROLE_LABELS } from '../../util';

export interface UserRoleChipProps extends ChipProps {
  roleType: RoleType;
}

export default function UserRoleChip({
  roleType,
  ...props
}: UserRoleChipProps) {
  const role = useMemo(() => ROLE_LABELS[roleType], [roleType]);

  return (
    <Chip size="sm" variant="flat" {...props} color={role.color}>
      {role.tag}
    </Chip>
  );
}
